<template>
	<modal :name="'event-description-' + event.id" :scrollable="true" :adaptive="true" :height="'auto'">
		<div class="container-fluid wa-modal event-description-modal">
			<div class="row">
				<div class="col-md-12">
					<h1>
						{{ event.title }}
					</h1>

					<div class="description" style="max-height: 500px; overflow-y: auto">
						<div v-html="event.description"></div>
					</div>

					<p>
						<a href="#" class="pull-right btn btn-default" v-on:click.prevent="close">
							{{ $t('common.close') }}
						</a>
					</p>
				</div>
			</div>
		</div>
	</modal>
</template>

<script>
export default {
	name: 'EventDescriptionModal',

	props: {
		event: {
			required: true,
			type: Object
		}
	},

	methods: {
		close: function() {
			this.$modal.hide('event-description-' + this.event.id);
		}
	},

	data: function () {
		return {
		};
	}
}
</script>

<style>
.event-description-modal {
	padding: 20px;
}
.v--modal-overlay {
	z-index: 9999;
}
.v--modal {
	max-height: 90%;
	overflow-y: auto;
}
</style>
